import { Box } from "@mui/material";
import {
  LICENSE_CODE_TO_DATA_MAP,
  getLicenseImage,
} from "Components/Licenses/licenseUtils";
import { ParameterList } from "Components/Shared/ParameterList/ParameterList";
import { useIsMobile } from "Hooks/useIsMobile";
import {
  LicensePaymentStatus,
  type PartyLicenseDto,
} from "Infrastructure/Api/Api";
import { useCountryNameResolver } from "Translations/countryNames";
import { Resources, useResource } from "Translations/Resources";

const ComponentResources = Resources.Pages.Content.LicenseDetail;

type Props = {
  license: PartyLicenseDto;
};

export const LicenseDetail = ({
  license: { code, paymentStatus, region, licenseNo, walletAddress },
}: Props) => {
  const { t } = useResource();
  const { getCountryName } = useCountryNameResolver();
  const isMobile = useIsMobile();

  const isActive = paymentStatus === LicensePaymentStatus.Success;
  const { title } = LICENSE_CODE_TO_DATA_MAP[code];

  const licenseParameters = [
    { label: t(ComponentResources.Type), value: title },
    { label: t(ComponentResources.LicenseNo), value: licenseNo || "-" },
    {
      label: t(ComponentResources.Country),
      value: getCountryName(region) || "-",
    },
    {
      label: t(ComponentResources.PaymentStatus),
      value: t(ComponentResources.LicenseStatus[paymentStatus]),
    },
    {
      label: t(ComponentResources.WalletAddress),
      value: walletAddress || "-",
      textSize: "small" as const,
    },
  ];

  return (
    <Box
      display="flex"
      justifyContent={isMobile ? "center" : "space-between"}
      flexWrap="wrap-reverse"
      gap={3}
    >
      <ParameterList
        items={licenseParameters}
        justifyContent="space-between"
        maxWidth="50%"
        gap={6}
      />
      <Box display="flex">
        <Box
          alt={title}
          component="img"
          src={getLicenseImage(code, region)}
          sx={{
            borderRadius: "10px",
            filter: isActive ? "none" : "grayscale(100%)",
            opacity: isActive ? "1" : "0.3",
            height: "425px",
          }}
        />
      </Box>
    </Box>
  );
};
